// report slice
import { createSlice } from "@reduxjs/toolkit";

const reportSlice = createSlice({
  name: "report",
  initialState: {
    reportId: null, // Set your default report ID here
  },
  reducers: {
    setReportId: (state, action) => {
      state.reportId = action.payload; // Action to update report ID
    },
    clearReportId: (state) => {
      state.reportId = null; // Action to clear report ID
    },
  },
});

export const { setReportId, clearReportId } = reportSlice.actions;
export default reportSlice.reducer;
